module.exports = __webpack_public_path__ + "img/QRCode.1a1ad528.png";